// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5c1ede4f","453":"1407b060"}[chunkId] + ".chunk.js";
};